import { useMutation, } from '@apollo/client';
import { useCallback, } from 'react';

import {
  SEND_TRANSACTIONAL_MESSAGE,
} from './message.queries';
import { ISendTransactionalMessageParams } from './message.types';

export const useSendTransactionalMessage = () => {
  const [mutation, rest] = useMutation<{ sendTransactionalMessage: boolean }, ISendTransactionalMessageParams>(SEND_TRANSACTIONAL_MESSAGE, {
    context: { serializationKey: 'MUTATION', tracked: true }
  });

  const sendTransactionalMessage = useCallback((variables: ISendTransactionalMessageParams) => mutation({ variables }), [mutation]);

  return { sendTransactionalMessage, ...rest };
};
